<template>
  <div class="stats-progress">
    <div class="list" v-infinite-scroll="load">
      <div
        class="item clearfix"
        v-for="(item, index) in dataList"
        :key="index"
        @click="detailFn(item.id)"
      >
        <div :class="'icon i-' + keyName"></div>
        <div class="info">
          <div class="name">{{ item.supplierName }}</div>
          <div class="progress clearfix">
            <div class="left">
              <i></i>
              <span>进度</span>
              <b>{{ item.progress }}%</b>
            </div>
            <div class="right">{{ item.businessStatusDesc }}</div>
            <el-progress :percentage="item.progress" />
          </div>
          <div class="other">
            <span>{{ item.custOrderNo }}</span>
            <!-- <span class="time" v-if="item.estimatedTimeArrival">预计{{ item.estimatedTimeArrival }}送达</span> -->
            <span class="time" v-if="item.estimatedTimeArrival && item.progress !== 100">预计{{ item.estimatedTimeArrival }}送达</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stats-progress', // 统计订单进度
  props: {
    keyName: {
      type: String,
      default: ''
    },

    sum: {
      type: Number,
      default: 0
    },

    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
        type: String,
        default: ''
    }
  },

  data() {
    return {
      dataList: this.list,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: this.sum
      }
    }
  },
  watch: {
    sum(value) {
      this.page.total = value || 0
    },

    list(value) {
      this.dataList = value || []
    }
  },

  computed: {
    
  },

  created() {
    
  },

  methods: {
    load() {
      if (this.page.currentPage * this.page.pageSize < this.page.total) {
        this.page.currentPage++
        this.getDataList()
      }
    },

    getDataList() {
        let url = this.type == 'exit'? '/oms/client/workbench/listAircraftTraceEx' : '/oms/client/workbench/listAircraftTrace'
      this.$post(url, {
        data: {
          queryType: this.keyName
        },
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then(({ data }) => {
        if (data && data.code === 'C0000' && data.result) {
          const groupData = data.result.groupData[this.keyName]
          this.dataList = this.dataList.concat(groupData.list || [])
          this.page.total = groupData.total
          this.$emit('updateSum', groupData.total)
        }
      })
    },

    detailFn(id) {
        let url = this.type == 'exit'? 'export-orders-detail' : '/import-orders-detail'
        this.$router.push({
            path: url,
            query: {
                status: 'edit',
                id: id,
                cache: false
            }
        })
    }
  }
}
</script>

<style lang="scss">
.stats-progress {
  width: 480px;
  padding: 20px 10px 20px 20px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
  .list {
    width: 100%;
    max-height: 344px;
    padding-right: 10px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #d0d0d0;
    }
    &::-webkit-scrollbar-track {
      background: #fff;
    }

    .item {
      padding: 20px 0;
      border-bottom: 1px solid #F0F2F5;
      cursor: pointer;
      .icon {
        float: left;
        width: 36px;
        height: 36px;
        margin-right: 8px;
        border-radius: 50%;
        background-color: #f0f2f5;
        background-repeat: no-repeat;
        background-position: center;
        &.i-1 {
          background-image: url(@/assets/img/dashboard/dot-icon-1.png);
        }
        &.i-2 {
          background-image: url(@/assets/img/dashboard/dot-icon-2.png);
        }
        &.i-3 {
          background-image: url(@/assets/img/dashboard/dot-icon-3.png);
        }
        &.i-4 {
          background-image: url(@/assets/img/dashboard/dot-icon-4.png);
        }
        &.i-5 {
          background-image: url(@/assets/img/dashboard/dot-icon-5.png);
        }
        &.i-6 {
          background-image: url(@/assets/img/dashboard/dot-icon-6.png);
        }
      }
      .info {
        float: left;
        width: calc(100% - 44px);
        .name {
          height: 20px;
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #000;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .progress {
          margin-top: 5px;
          .left {
            float: left;
            width: 50%;
            > * {
              display: inline-block;
              vertical-align: middle;
            }
            i {
              width: 17px;
              height: 15px;
              margin-right: 4px;
              background: url(@/assets/img/dashboard/car.png) no-repeat;
            }
            b {
              margin-left: 5px;
              font-size: 16px;
              font-weight: bold;
              color: #1165D4;
            }
          }
          .right {
            float: left;
            width: 50%;
            color: #1165D4;
            text-align: right;
          }
          .el-progress {
            float: left;
            width: 100%;
            margin-top: 5px;
            .el-progress-bar__outer {
              height: 4px !important;
            }
            .el-progress__text {
              display: none;
            }
          }
        }
        .other {
          display: flex;
          justify-content: space-between;
          margin-top: 5px;
          .time {
            color: #F37041;
          }
        }
      }
    }
  }
}
</style>
